import { render, staticRenderFns } from "./EventFeedbackBlock.vue?vue&type=template&id=3067f6df&scoped=true"
import script from "./EventFeedbackBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./EventFeedbackBlock.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./EventFeedbackBlock.vue?vue&type=style&index=0&id=3067f6df&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3067f6df",
  null
  
)

export default component.exports